import "./OptionGridStrikesComponent.scss";
import {IComponentOptions} from "angular";

export const OptionGridStrikes = "tfOptionGridStrikes";

export function optionGridStrikes(): IComponentOptions {
    return {
        templateUrl: "app/services/option-chain/popup/strikes/OptionGridStrikesComponent.html",
        bindings: {
            strikes: "<",
            underlying: "<"
        },
        controllerAs: "ctrl",
        controller: OptionGridStrikesComponentController
    };
}

export class OptionGridStrikesComponentController {
    public strikes: Array<number>;
    public underlying: string;
}
